import { ReactElement } from 'react';
import { Field, useFormikContext } from 'formik';
import { tile } from '@interfaces/interfaces';
import { iThirdPartyFormValues } from '@services/ThirdPartyService';
import { AddressField, ContactInputWithExperian, EmailFieldWithExperian, TextInput, TileRadio } from '@components';
import { FormType } from '@constants/forms';
import gridFormStyles from '@pages/forms/Grid.module.scss';

import styles from './OrganisationForm.module.scss';

const OrganisationForm = (): ReactElement => {
  const { values } : { values : iThirdPartyFormValues } = useFormikContext();

  const PostalAddress = (): ReactElement => (
    <>
      <div>Yes</div>
    </>
  );

  const NotPostalAddress = (): ReactElement => (
    <>
      <div>No</div>
    </>
  );

  const TILE_DATA: tile[] = [
    {
      body: <PostalAddress />,
      value: 'true',
    },
    {
      body: <NotPostalAddress />,
      value: 'false',
    },
  ];

  return (
    <div className={styles.container}>
      <div className={gridFormStyles.form}>
        <Field name="OrganisationName" component={TextInput} title="Organisation name" isMandatory />
        <AddressField
          name="OrganisationAddress"
          title="Street address"
          manualAddressText="Enter the address manually"
          isMandatory
        />
        <Field
          name="IsOrganisationAddressDifferentFromPostal"
          component={TileRadio}
          tileData={TILE_DATA}
          orientationRow
          mobileCollapseRow={false}
          title="Is the organisation's postal address different to its street address?"
          isMandatory
        />
        {values.IsOrganisationAddressDifferentFromPostal === 'true' && <AddressField name="OrganisationPostalAddress" title="Postal address" manualAddressText="Enter the address manually" isMandatory />}
        <Field component={ContactInputWithExperian} name="OrganisationContactNumber" title="Contact phone number" isMandatory orientationRow obligationNumber={values.OBLIGATION_NUMBER} formName={FormType.THIRDPARTY} secondaryContact={false} hasPrimaryNumberType={false} warningMessage="OrganisationContactNumberWarning" />
        <Field component={EmailFieldWithExperian} name="EmailAddressOptionalTwo" title="Email" isMandatory orientationRow obligationNumber={values.OBLIGATION_NUMBER} formName={FormType.THIRDPARTY} noEmailField="NoEmailAddressTwo" currentSP="Select if they do not have an email address" warningMessage="EmailAddressOptionalTwoWarning" />
        <Field name="YourReferenceNumberWithinTheOrganisationOptional" component={TextInput} title="Your reference number within the organisation" />
      </div>
    </div>
  );
};

export default OrganisationForm;
